import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-10 sm:py-12 px-4" data-id="element-149">
      <div className="max-w-xl mx-auto" data-id="element-150">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-card border border-brand-gold/30 p-6 sm:p-8 rounded-2xl text-center relative overflow-hidden" data-id="element-151">
          <div className="absolute top-0 right-0 w-32 h-32 bg-brand-gold/10 rounded-full blur-3xl" data-id="element-152" />
          <div className="absolute bottom-0 left-0 w-32 h-32 bg-brand-orange/10 rounded-full blur-3xl" data-id="element-153" />

          <p className="text-xs font-black uppercase tracking-widest text-brand-orange mb-3 relative z-10" data-id="element-154">
            Garanzia totale
          </p>

          <ShieldCheckIcon className="w-14 h-14 text-brand-gold mx-auto mb-4 relative z-10" data-id="element-155" />

          <div className="inline-block bg-gradient-to-r from-brand-orange to-brand-gold text-black font-black px-4 py-1 rounded-full mb-4 uppercase tracking-wider text-xs relative z-10" data-id="element-156">
            14 GIORNI
          </div>

          <h3 className="text-2xl sm:text-3xl font-black text-brand-cream mb-4 relative z-10 leading-tight" data-id="element-157">
            Rischio zero, 14 giorni di prova
          </h3>

          <p className="text-lg sm:text-xl font-bold text-brand-gold mb-4 relative z-10" data-id="element-158">
            Recupera il tuo tempo, o ti rimborsiamo.
          </p>

          <div className="text-gray-300 text-base sm:text-lg font-medium leading-relaxed relative z-10 space-y-3" data-id="element-159">
            <p data-id="element-160">
              Siamo così sicuri del Metodo Economia Aziendale Pro™ che ti diamo{' '}
              <strong className="text-brand-gold" data-id="element-161">14 giorni interi</strong> per
              metterlo alla prova. Se non senti che il tuo lavoro è diventato
              più veloce, facile e organizzato, ti restituiamo ogni centesimo.
            </p>
            <p className="text-brand-cream font-bold" data-id="element-162">
              Tu provi, noi ci assumiamo il rischio.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}